import { render, staticRenderFns } from "./KCheckbox.vue?vue&type=template&id=18f634e8&"
import script from "./KCheckbox.vue?vue&type=script&lang=js&"
export * from "./KCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./KCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports